import {createStyles, makeStyles} from "@mui/styles";
import React from "react";
import Paper from "@mui/material/Paper";

const useStyles = makeStyles((theme) =>
  createStyles({
    ticket: {
      padding: 10,
      fontSize: 14,
      position: 'relative'
    },
  }),
);

const Card = ({children, style={}, className, onClick = () => {}}) => {
  const classes = useStyles();
  return (
    <Paper className={`${classes.ticket} ${className}`} style={style} onClick={onClick}>
      {children}
    </Paper>
  );
};

export default Card;
